import { InferOutput, literal, object } from 'valibot'
import { CurrentEDCSSchema } from '../../Current/CurrentEDCS.type'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_SEA_FLOOR_DEFAULT, ELEVATION_WATER_LEVEL_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Sea,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_SEA_FLOOR_DEFAULT,
  water_e: ELEVATION_WATER_LEVEL_DEFAULT,
} as const

export const SeaEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Sea),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  current: CurrentEDCSSchema,
  ...HasXYSchema.entries,
})

export type SeaEntity = InferOutput<typeof SeaEntitySchema>

/**
 * Large body of salt water that covers most of Earth's surface.
 */
export const SeaEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Sea,
  dname: 'Sea',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createSeaEntity(id: number, x: number, y: number): SeaEntity {
  return {
    ...entDefaults,
    heading: 0,
    current: {
      edc: 0,
      s: 0,
    },
    id,
    x,
    y,
  }
}
